module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAqBAMAAAD8NjCWAAAAElBMVEUAAACzuNCzudGyudCyuNGzudDPdiQ7AAAABXRSTlMA8r1MheKcwngAAABFSURBVDjLY2AwEg3FBwKVGRhYQgkBBwZTgmqCGVQJqgliECWoJpAhlDAYVTOqZlTNqBpaqCGmjCKmrCOmzCSm7CWmDAcARa7joj2gQPIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gray_icon.png
// module id = IKKb
// module chunks = 167